const forEach = require('lodash/forEach');
const ACTIVE_CLASS = 'active';

class TabNavigation {
  constructor(root) {
    this.root = root;

    this.map();
    this.bind();
    this.setCurrent();
  }

  bind() {
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);

    forEach(this.data, tab => {
      tab.link.addEventListener('click', (e) => {
        e.preventDefault();
        this.changeTo(tab);
      });
    });
  }

  map() {
    this.data = [];
    this.links = this.root.querySelectorAll('[data-nav-tab-link]');

    forEach(this.links, link => {
      const id = link.dataset.navTabLink;
      const target = document.querySelector(`${id}`);
      const parent = link.parentNode;
      const isActive = parent.classList.contains(ACTIVE_CLASS);

      if (!id || !target) {
        return;
      }

      this.data.push({ link, id, target, parent, isActive });
    });
  }

  changeTo(tab) {
    this.hideAll();
    this.show(tab);
  }

  hideAll() {
    forEach(this.data, this.hide);
  }

  hide(tab) {
    tab.target.style.display = 'none';
    tab.parent.classList.remove(ACTIVE_CLASS);
    tab.isActive = false;
  }

  show(tab) {
    tab.target.style.display = 'block';
    tab.parent.classList.add(ACTIVE_CLASS);
    tab.isActive = true;
  }

  setCurrent() {
    forEach(this.data, tab => {
      this[tab.isActive ? 'show': 'hide'](tab);
    });
  }
}

module.exports = TabNavigation;
